import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SNItemFactory } from '../models/snitemfactory';
import { BecareService } from './becare.service';

@Injectable({
  providedIn: 'root'
})
export class UserStoreService {

  constructor(private becare: BecareService) { }

  store(name: string, payload: any) {
    const payloadToSend = (typeof(payload) === 'string') ? payload : JSON.stringify(payload);
    this.becare.call('/user/store', [],
      {
        payloadname: name,
        payload: payloadToSend
      }, 'post').subscribe(result => {
    });
  }

  load(name: string): Observable<any> {
    return new Observable(observer => {
      this.becare.call('/user/store/' + name).subscribe(payloadStored => {
        observer.next(payloadStored.payload);
      });
    });
  }

  clean(name: string): Observable<boolean> {
    return this.becare.call('/user/store/' + name + '/clean');
  }
}
